import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { EditCompanyFormData } from "../../schemas/companySchemas";

interface FieldServiceSoftware {
  id: number;
  name: string;
}

interface SoftwareSectionProps {
  form: UseFormReturn<EditCompanyFormData>;
  fieldServiceSoftwareList: FieldServiceSoftware[];
}

export const SoftwareSection: React.FC<SoftwareSectionProps> = ({
  form,
  fieldServiceSoftwareList,
}) => {
  const { control } = form;

  return (
    <div className="space-y-6">
      <FormField
        control={control}
        name="fieldServiceSoftwareId"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Field Service Software</FormLabel>
            <Select
              onValueChange={(value) => {
                field.onChange(value === "none" ? null : parseInt(value, 10));
              }}
              value={field.value?.toString() || "none"}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select software" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="none">No Software Selected</SelectItem>
                {fieldServiceSoftwareList.map((software) => (
                  <SelectItem key={software.id} value={software.id.toString()}>
                    {software.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormDescription>
              Select the field service software used by this company
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="rounded-lg bg-muted p-4">
        <h4 className="text-sm font-medium mb-2">Software Integration</h4>
        <p className="text-sm text-muted-foreground">
          Selecting a field service software will enable integration features
          and allow data synchronization with the selected platform.
        </p>
      </div>
    </div>
  );
};
